import {
  OrderForDeliveryWithAuPayRequest,
  OrderForDeliveryWithAuPayResponse,
} from "src/modules/api/Order/orderForDeliveryWithAuPay/types";
import { ApiKey } from "../../common/request/apiKey";
import { useApiTrigger } from "../../common/request/useApiTrigger";

export const useOrderForDeliveryWithAuPay = () => {
  return useApiTrigger<
    OrderForDeliveryWithAuPayResponse,
    OrderForDeliveryWithAuPayRequest
  >({
    method: ApiKey.ORDER_FOR_DELIVERY_WITH_AU_PAY,
  });
};
